import { UserMultiple } from '@carbon/icons-react';
import { HorizBox, Pad, PadBox } from 'component/basics';
import { colorTextOnAccentColorBg } from 'component/color';
import { spacings } from 'component/constants';
import { UtilityText } from 'component/text';
import { useGlobalProperty } from 'util/datastore';
import type { Feature } from 'util/stdtypes';
import { declareGlobalProperty, t } from 'util/stdtypes';

const participantCountProperty = declareGlobalProperty<number>('participantCount');

export function FakeTopicParticipantsWidget() {
    const count = useGlobalProperty(participantCountProperty) ?? 5;

    return (
        <PadBox top={24}>
            <HorizBox>
                <UserMultiple color={colorTextOnAccentColorBg} />
                <Pad size={spacings.xs} />
                <UtilityText
                    color={colorTextOnAccentColorBg}
                    formatParams={{ count, singular: t('participant'), plural: t('participants') }}
                    label={t('{count} {noun}')}
                />
            </HorizBox>
        </PadBox>
    );
}
